import * as d3 from "d3";
import dataComponentMixin from "./data-component-mixin.js";

// Handles D3 basic concepts (canvas/margin)
export default {
  mixins: [dataComponentMixin],
  methods: {
    D3Prepare() {
      // Credits to: http://bl.ocks.org/d3noob/b3ff6ae1c120eea654b5
      // Drawing height and width
      // Set the canvas size
      this.graphWidth = this.canvasWidth - this.margin.left - this.margin.right;
      this.graphHeight =
        this.canvasHeight - this.margin.top - this.margin.bottom;
      // Adds the svg canvas
      this.dom_canvas = d3
        .select(this.$refs.canvas)
        .append("svg")
        .style("fill", "purple")
        .attr(
          "viewBox",
          `0 0 ${this.graphWidth + this.margin.left + this.margin.right} ${this
            .graphHeight +
            this.margin.top +
            this.margin.bottom}`
        )
        //.attr("height", this.graphHeight + this.margin.top + this.margin.bottom)
        //.attr("width", this.graphWidth + this.margin.left + this.margin.right)
        .append("g")
        .attr("class", "interactive_zone")
        .attr("position", "relative")
        .attr(
          "transform",
          "translate(" +
            (this.margin.left - this.margin.right) +
            "," +
            this.margin.top +
            ")"
        );
    },
    D3Tick() {
      // TODO: check if it is the responsibility of the graph component (eg. HistogramComponent)
      this.getData();
    }
  },
  computed: {
    clipAreaId() {
      return `${this.getId()}ClipArea`;
    },
    clipAreaURL() {
      return `url(#${this.clipAreaId})`;
    },
    canvasWidth() {
      return this.attributes.width;
    },
    canvasHeight() {
      return this.attributes.height;
    },
    typeScale() {
      return this.attributes.scale;
    },
    margin() {
      var margin = {};
      margin.top = parseInt(this.attributes.margin_top || 30);
      margin.right = parseInt(this.attributes.margin_right || 20);
      margin.bottom = parseInt(this.attributes.margin_bottom || 30);
      margin.left = parseInt(this.attributes.margin_left || 50);
      return margin;
    }
  }
};
